import TravelReasonRepository from '@/shared/http/repositories/configuration/travelreason'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
export default {
  name: 'TermTravekModal',
  mixins: [ActionsForm],
  props: ['dataPerson', 'total', 'motivoViagemId', 'dataobj'],

  data () {
    return {
      checked: false,
      BoolMotivoViagem: false,
      hasFile: false,
      valorSolicitado: {},
      nameFile: '',
      dataFinal: [],
      file: []
    }
  },
  mounted () {
    this.MotivoViagemVenda(this.motivoViagemId)
  },
  methods: {
    MotivoViagemVenda (id) {
      if (id) {
        TravelReasonRepository.motivoViagemVenda(id)
          .then(Response => {
            this.BoolMotivoViagem = Response.data
            this.GetAllDespes(this.BoolMotivoViagem)
          })
          .catch(Error => console.log(Error))
      }
    },
    print () {
      loading.push()
      let data = this.fortmDataobj(this.dataobj)
      AcceptanceTermRepository.printVenda(data)
        .then(Response => {
          let pdf = Response.data.data
          let linkSource = `data:application/pdf;base64,${pdf}`
          let downloadLink = document.createElement('a')
          let fileName = 'Assinatura.pdf'
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    fortmDataobj (data = {}) {
      let dataFinal = {}
      Object.keys(data).forEach((Element) => {
        dataFinal[Element] = data[Element].value
      })
      dataFinal['EmpresaId'] = this.CompanySelected
      return dataFinal
    },
    addImg () {
      document.getElementById('input-hidden').click()
    },
    setValueInput (e) {
      if (e.target.files.length > 0) {
        this.file = e.target.files[0]
        this.hasFile = true
        this.checked = true
        this.nameFile = e.target.files[0].name
      } else {
        this.hasFile = false
        this.file = []
      }
    },
    removeFile () {
      document.getElementById('input-hidden').value = ''
      this.hasFile = false
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/TermTravekModal/TermTravekModal.js